import { defineStore } from "pinia";
import ModuleFactory from "@/library/modules/moduleFactory";
import { useContentStore } from "./content";
import UserComponentCreator from "@/library/modules/userComponentCreator";
// import ComponentCircleCreator from "../library/componentCircleCreator";

// store of default module settings
// pos, translate and rotation are common propertyName for all the modules
export const useMoudleStore = defineStore("module", {
  state: () => {
    const factory = [...ModuleFactory];
    try {
      const saved = localStorage.getItem('flui3d_user_components');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          parsed.forEach(jsonData => {
             factory.push(new UserComponentCreator(jsonData));
          });
        }
      }
    } catch (e) {
      console.warn("Failed to load user components on startup", e);
    }
    
    return {
      moduleFactory: factory,
      selectedModuleIdx: 0
    };
  },

  getters: {
    selectedModuleCreator(state) {
      return state.moduleFactory[state.selectedModuleIdx];
    }
  },

  actions: {
    selectModule(idx: number) {
      this.selectedModuleIdx = idx;
    },

    loadUserComponents() {
      const saved = localStorage.getItem('flui3d_user_components');
      if (saved) {
        try {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) {
            // Remove existing user components to prevent duplicates
            this.moduleFactory = this.moduleFactory.filter(c => !(c as any).isUserComponent);
            
            parsed.forEach(jsonData => {
               this.moduleFactory.push(new UserComponentCreator(jsonData));
            });
          }
        } catch(e) {
          console.warn("Failed to load user components", e);
        }
      }
    },

    saveUserComponents() {
      const userComponents = this.moduleFactory
        .filter(c => (c as any).isUserComponent)
        .map(c => (c as any).jsonData);
      localStorage.setItem('flui3d_user_components', JSON.stringify(userComponents));
    },

    removeUserComponent(idx: number) {
       this.moduleFactory.splice(idx, 1);
       this.saveUserComponents();
    },

    // invoked when initialize design
    initiallizeModuleFactory() {
      this.loadUserComponents();
      this.moduleFactory.forEach((creator) => {
        creator.resetModule();
      });
      const contentStore = useContentStore();
      this.moduleFactory.forEach((moduleCreator) => {
        moduleCreator.pendingModule.properties.height.value =
          contentStore.chipProperties[4].value;
        if ("channelWidth" in moduleCreator.pendingModule.properties) {
          moduleCreator.pendingModule.properties.channelWidth.value =
            contentStore.chipProperties[3].value;
        }
        if ("reflowRadius" in moduleCreator.pendingModule.properties) {
          moduleCreator.pendingModule.properties.reflowRadius.value =
            contentStore.reflowStructure;
        }
      });
    }
  }
});
